import { SsoPage as SsoPageBase } from 'shared/pages/SsoPage'
import Api from 'ui/libs/api'

export default function SsoPage() {
  return (
    <SsoPageBase
      platform="consultant"
      apiBaseUrl={Api.getBaseUrl()}
    />
  )
}
